import { useCallback, useContext } from "react";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";
import { TemplateContractsContext } from "../contexts/ContractsContext";
import { notify } from "../../../../utils/notify";
import {
  updateModeloContrato,
  createModeloContrato,
} from "../../../../repositories/qerpapi/erp/faturamento/ContratoModeloRepository";
import { findEmpresasV2 } from "../../../../repositories/qerpapi/erp/prouser/v2/EmpresasRepository";
import {
  deleteModeloContrato,
  GetModel,
  findContratoModelo,
} from "../../../../repositories/qerpapi/erp/faturamento/ContratoModeloRepository";
import { findContrato } from "../../../../repositories/qerpapi/erp/faturamento/ContratoRepository";
import { searchByType } from "../../../../repositories/qerpapi/erp/faturamento/TagRepository";
import { useHistory } from "react-router-dom";
import { validNotNull } from "../../../../utils/validations";

export default function ContractsController() {
  const {
    setMainLoading,
    setRoutine,
    contractDescription,
    setContractDescription,
    companyList,
    setCompanyList,
    active,
    setActive,
    modelId,
    setModelId,
    setShowCompanies,
    setTagListBody,
    setErrorsSubmit,
    setBodyDesign,
    exportDataEditor,
    setExportDataEditor,
  } = useContext(TemplateContractsContext);

  const { queryParams } = useContext(QueryParamsContext);

  const { push } = useHistory();

  const clearContext = useCallback(() => {
    setRoutine("");
    setContractDescription("");
    setBodyDesign("");
    setModelId(null);
    setCompanyList([]);
    setExportDataEditor({});
  }, [
    setRoutine,
    setContractDescription,
    setModelId,
    setCompanyList,
    setExportDataEditor,
    setBodyDesign,
  ]);

  const initHeandleInputs = useCallback(
    async (id, clonar) => {
      if (!queryParams?.empresa_cnpj && id) return;

      clearContext();

      try {
        setMainLoading(true);
        var modelosCallback = null;

        if (id) {
          modelosCallback = await GetModel({
            empresa_cnpj: queryParams?.empresa_cnpj,
            id: id,
            include: "empresa",
          });
        } else {
          modelosCallback = await findContratoModelo({
            empresa_cnpj: queryParams?.empresa_cnpj,
            include: "empresa",
          });
        }

        const [companies, tagsBodyCallback] = await Promise.all([
          findEmpresasV2(queryParams?.empresa_cnpj),
          searchByType({
            empresa_cnpj: queryParams?.empresa_cnpj,
            body: { tag: { tipo: "modelo" } },
          }),
        ]);

        if (
          !companies?.success ||
          !modelosCallback?.success ||
          !tagsBodyCallback?.success
        )
          return notify("Erro ao buscar dados.");

        const checks = companies.data.map((companyExist) => {
          if (id) {
            return {
              ...companyExist,
              check: (modelosCallback?.data?.empresa || []).some(
                (comp) => comp?.id === companyExist?.id
              ),
            };
          } else
            return {
              ...companyExist,
              check: true,
            };
        });
        setShowCompanies(companies.data.length > 1);
        setContractDescription(modelosCallback.data?.descricao || "");
        setActive(
          modelosCallback.data?.ativo
            ? modelosCallback.data?.ativo === "S"
            : true
        );
        setCompanyList(checks);
        setModelId(clonar ? null : id ?? null);

        var bodyTagList = {
          cliente: {
            name: "Cliente",
            mergeTags: {},
          },
          company: {
            name: "Empresa",
            mergeTags: {},
          },
          contract: {
            name: "Contrato",
            mergeTags: {},
          },
        };
        tagsBodyCallback.data.forEach((tagBody) => {
          if (tagBody.valor.includes("cliente_")) {
            bodyTagList.cliente.mergeTags[
              tagBody.nome.toLowerCase().replace(" ", "_").replace(".", "_")
            ] = {
              name: tagBody.nome,
              value: tagBody.valor,
            };
          }
          if (tagBody.valor.includes("empresa_")) {
            bodyTagList.company.mergeTags[
              tagBody.nome.toLowerCase().replace(" ", "_").replace(".", "_")
            ] = {
              name: tagBody.nome,
              value: tagBody.valor,
            };
          }
          if (tagBody.valor.includes("contrato_")) {
            bodyTagList.contract.mergeTags[
              tagBody.nome.toLowerCase().replace(" ", "_").replace(".", "_")
            ] = {
              name: tagBody.nome,
              value: tagBody.valor,
            };
          }
        });

        setTagListBody(bodyTagList);

        if (modelosCallback.data?.body_design) {
          setBodyDesign(
            modelosCallback.data?.body_design?.body
              ? modelosCallback.data?.body_design
              : JSON.parse(modelosCallback.data?.body_design)
          );
          setExportDataEditor((prev) => ({
            ...prev,
            design: modelosCallback.data?.body_design?.body
              ? modelosCallback.data?.body_design
              : JSON.parse(modelosCallback.data?.body_design),
          }));
        }

        if (modelosCallback.data?.main_body) {
          setExportDataEditor((prev) => ({
            ...prev,
            html: modelosCallback.data?.main_body,
          }));
        }
      } catch (error) {
        console.error(error);
      } finally {
        setMainLoading(false);
      }
    },
    [
      queryParams?.empresa_cnpj,
      setMainLoading,
      setContractDescription,
      setActive,
      setCompanyList,
      setModelId,
      setShowCompanies,
      setTagListBody,
      setBodyDesign,
      setExportDataEditor,
      clearContext,
    ]
  );

  const store = async () => {
    try {
      const checks = companyList.find((company) => company.check);
      if (!checks)
        return notify("Selecione ao menos uma empresa", true, "warning");

      const jsonValidMain = [
        {
          key: "description",
          value: contractDescription,
        },
      ];
      const validateSubmit = validNotNull(jsonValidMain);

      setErrorsSubmit({
        ...validateSubmit.errorsValidation,
      });

      if (validateSubmit.error)
        return notify(
          "Verifique se os campos foram preenchidos corretamente.",
          true,
          "warning"
        );

      const companiesSelected = [];
      companyList.forEach((company) => {
        if (company.check) {
          companiesSelected.push({
            empresa_id: company.id,
          });
        }
      });

      const body = {
        contrato_modelo: {
          descricao: contractDescription,
          ativo: active ? "S" : "N",
          main_body: exportDataEditor?.html || "",
          body_design: JSON.stringify(exportDataEditor?.design || ""),
          empresas: companiesSelected ?? [
            {
              empresa_id: queryParams?.empresa_id,
            },
          ],
        },
      };

      setMainLoading(true);

      let callback = {};

      if (modelId) {
        callback = await updateModeloContrato({
          id: modelId,
          empresa_cnpj: queryParams.empresa_cnpj,
          body,
        });
      } else {
        callback = await createModeloContrato({
          empresa_cnpj: queryParams.empresa_cnpj,
          body,
        });
      }

      if (!callback.success)
        return notify("Erro ao salvar Modelo de Contrato.");

      push("listagem");
      clearContext();
      return notify(
        `Modelo Contrato ${modelId ? `Atualizado` : `Cadastrado`}`,
        true,
        "success"
      );
    } catch (error) {
      console.error(error);
    } finally {
      setMainLoading(false);
    }
  };

  const destroy = async (id) => {
    try {
      setMainLoading(true);
      const contratoCallbacks = await findContrato({
        empresa_cnpj: queryParams?.empresa_cnpj,
        where: { id_modelo_contrato: id },
      });

      if (!contratoCallbacks?.success)
        return notify("Erro ao verificar contratos para exclusão.");

      if (contratoCallbacks.data.length > 0)
        return notify(
          "Modelo Contrato Vinculado ao Tipo de Serviço, não poderá excluir.",
          true,
          "warning"
        );

      let callback = {};

      callback = await deleteModeloContrato({
        id: id,
        empresa_cnpj: queryParams.empresa_cnpj,
      });

      if (!callback.success)
        return notify("Erro ao Deletar Modelo de Contrato.");

      push("listagem");
      clearContext();
      return notify(`Modelo Contrato Excluído com Sucesso`, true, "success");
    } catch (error) {
      console.error(error);
    } finally {
      setMainLoading(false);
    }
  };

  const handleCheckCompany = (companyId) => {
    const copyCheckCompanies = [...companyList];
    const companyIndex = copyCheckCompanies.findIndex(
      (comp) => comp.id === companyId
    );

    copyCheckCompanies[companyIndex] = {
      ...copyCheckCompanies[companyIndex],
      check: !copyCheckCompanies[companyIndex].check,
    };

    if (!copyCheckCompanies.filter((e) => e.check).length)
      return notify("Ao menos uma empresa deve estar selecionada.");

    setCompanyList(copyCheckCompanies);
  };

  const handleCloneModel = async ({ item }) => {
    item.cloned = true;
    push(
      "cadastro?empresa_cnpj=" +
        queryParams.empresa_cnpj +
        "&empresa_id=" +
        queryParams.empresa_id,
      { item }
    );
  };

  return {
    initHeandleInputs,
    store,
    destroy,
    clearContext,
    handleCheckCompany,
    handleCloneModel,
  };
}
